import { useEffect } from 'react';
import "./googleTranslate.css";

type GoogleTranslateLayout = 'SIMPLE' | 'MENU' | 'DROPDOWN';

// Extend the Window interface to include googleTranslateElementInit
declare global {
  interface Window {
    googleTranslateElementInit: () => void;
    google: {
      translate: {
        TranslateElement: new (
          options: { pageLanguage: string, includedLanguages: string, layout: GoogleTranslateLayout, autoDisplay: boolean },
          elementId: string,
        ) => void;
      };
    };
  }
}

// Function to initialize the Google Translate Element
const initializeGoogleTranslate = (language: string) => new window.google.translate.TranslateElement({
  pageLanguage: 'en',
  includedLanguages: language,
  layout: 'SIMPLE' as GoogleTranslateLayout,
  autoDisplay: false,
}, 'google_translate_element');

const GoogleTranslate = ({ language }: { language: string }) => { 

  useEffect(() => {
    const setGoogleTranslateCookie = () => {
      document.cookie = `googtrans=/en/${language}; path=/`;
      document.cookie = `googtrans=/en/${language}; domain=."${window.location.hostname}"; path=/`;
    };

    const script = document.createElement('script');
    script.src = '//translate.google.com/translate_a/element.js?cb=googleTranslateElementInit';
    script.async = true;
    document.body.appendChild(script);

    window.googleTranslateElementInit = () => {
      setGoogleTranslateCookie(); // Set the cookie for language
      initializeGoogleTranslate(language); // Call the initialized function
    };

    return () => {
      document.body.removeChild(script);
    };

  }, []);

  return (
    <div id="google_translate_element" />
  );
};

export default GoogleTranslate;
